import { UiConfigDiscountType } from 'src/lib/types/discountsV2'
import { useDiscountForm } from '../../hooks/useDiscountForm'
import DiscountApplicationRulesBundle from './BundleDiscount/DiscountApplicationRulesBundle'
import DiscountApplicationRulesAmountOff from './AmountOff/DiscountApplicationRulesAmountOff'
import DiscountApplicationRulesBxgy from './BXGY/DiscountApplicationRulesBxgy'
import DiscountApplicationRulesShipping from './Shipping/DiscountApplicationRulesShipping'
import DiscountApplicationRulesAmountOffProducts from './AmountOffOnProducts/DiscountApplicationRulesAmountOffProducts'
import DiscountApplicationRulesAmountOffUpto from './AmountOffUpto/DiscountApplicationRulesAmountOffUpto'
import DiscountApplicationRulesBxgyAutoAdded from './BXGY/DiscountApplicationRulesBxgyAutoAdded'
import DiscountApplicationRulesFreebie from './Freebie/DiscountApplicationRulesFreebie'
import DiscountApplicationRulesFreebieSelector from './Freebie/DiscountApplicationRulesFreebieSelector'
import DiscountApplicationRulesExitCoupon from './ExitCoupon/DiscountApplicationRulesExitCoupon'

const  DiscountApplicationRulesV2 = () => {
  const {
    state: {
      uiConfig: { type }
    }
  } = useDiscountForm()

  switch (type) {
    case UiConfigDiscountType.BUNDLE:
      return <DiscountApplicationRulesBundle />
    case UiConfigDiscountType.AMOUNT_OFF:
      return <DiscountApplicationRulesAmountOff />
    case UiConfigDiscountType.AMOUNT_OFF_UPTO:
      return <DiscountApplicationRulesAmountOffUpto />
    case UiConfigDiscountType.AMOUNT_OFF_PRODUCTS:
      return <DiscountApplicationRulesAmountOffProducts />
    case UiConfigDiscountType.BXGY:
      return <DiscountApplicationRulesBxgy />
    case UiConfigDiscountType.BXGY_AUTO_ADDED:
      return <DiscountApplicationRulesBxgyAutoAdded />
    case UiConfigDiscountType.SHIPPING:
      return <DiscountApplicationRulesShipping />
    case UiConfigDiscountType.FREEBIE:
      return <DiscountApplicationRulesFreebie />
    case UiConfigDiscountType.FREEBIE_SELECTOR:
      return <DiscountApplicationRulesFreebieSelector />
    case UiConfigDiscountType.EXIT_COUPON:
      return <DiscountApplicationRulesExitCoupon />
    default:
      return <></>
  }
}

export default DiscountApplicationRulesV2
